import { getEnvVariables } from '../services/optionsService.ts';
import { loadInstanceName } from './oidc/oidcAuthInfo.ts';

/**
 * The environment's generic gateway host, used on localhost only when there is no better
 * instance identifier available. It resolves to the environment's corporate instance.
 */
const getLocalGatewayHost = (): string => {
  const { ssoAuthority } = getEnvVariables();
  const env = ssoAuthority ? new URL(ssoAuthority).hostname.split('.')[0] : 'devint';

  return `ui.${env}.gcp.openx.org`;
};

/**
 * The instance identifier to use wherever the app needs to name "the current instance" (e.g. the
 * SSO token-exchange `authorization_details[].identifier`, type `instance_name`).
 *
 * Prefers the stored instance name (set via oidcAuthInfo, custom-domain detection or the
 * instance-slugged URL). Falls back to the URL/hostname when nothing has been stored yet (e.g. a
 * user's very first login, before any instance context exists) - and on localhost, where every
 * app shares one origin and no hostname names an instance, to the generic gateway host.
 */
export const getXOpenxInstance = (takeWorkAsIntoConsideration = false): string => {
  const storedInstanceName = loadInstanceName(takeWorkAsIntoConsideration);

  if (storedInstanceName) {
    return storedInstanceName;
  }

  const { hostname } = window.location;

  return hostname === 'localhost' ? getLocalGatewayHost() : hostname;
};

export const getXOpenxInstanceHeader = (instanceUid?: string): string => {
  const storedInstanceName = loadInstanceName(true);

  if (storedInstanceName) {
    return storedInstanceName;
  }

  if (window.location.hostname === 'localhost' && instanceUid) {
    return instanceUid;
  }

  return getXOpenxInstance(true);
};
